import {
  Component,
  OnInit,
  ChangeDetectorRef,
  OnDestroy,
  AfterViewChecked,
} from '@angular/core';
import { ITabGroup, IPolizaVitalicia } from 'src/app/shared/Entities/entities';
import { Subscription } from 'rxjs/internal/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { EventsService } from 'src/app/shared/services/events.service';
import {
  getValuePageView,
  PageView,
} from 'src/app/shared/enums/insights/page-view';
import { v4 as uuidv4 } from 'uuid';
import { AppInsightsService } from 'src/app/shared/services/app-insights-service';
import { Event } from 'src/app/shared/enums/insights/event';

@Component({
  selector: 'app-seguro-privado-main',
  templateUrl: './seguro-privado-main.component.html',
  styleUrls: ['./seguro-privado-main.component.sass'],
})
export class SeguroPrivadoMainComponent
  implements OnInit, OnDestroy, AfterViewChecked {
  showRescate = false;
  idPoliza: string;
  nombreProd = '';
  tipo: string;
  numPersona: string;

  tab: ITabGroup = {
    selectedIndex: 0,
    tabs: [
      { index: 0, label: 'Resumen', tabName: 'Resumen' },
      { index: 1, label: 'Liquidaciones', tabName: 'Liquidaciones' },
      { index: 2, label: 'Tutoría Legal', tabName: 'TutoríaLegal' },
      /* {
        index: 3,
        label: 'Créditos Pensionados',
        tabName: 'CréditosPensionados',
      },
      { index: 4, label: 'Cargas Familiares', tabName: 'CargasFamiliares' },
      { index: 5, label: 'Caja Compensación', tabName: 'CajaCompensación' },
      { index: 6, label: 'Certificados', tabName: 'Certificados' },
      { index: 7, label: 'Beneficios', tabName: 'Beneficios' }, */
    ],
  };
  selectedTabIndex: number;
  private subscriptions: Subscription[] = [];
  printData: Array<{ type: string; content: any }>;
  private previousNameTrack: string;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private eventSrv: EventsService,
    private cdRef: ChangeDetectorRef,
    private appInsightsService: AppInsightsService
  ) {
    const sub = this.eventSrv.routerTabNavigation$.subscribe(data => {
      if (!data) {
        return;
      }
      this.setTabIndex(data.rootTabParent, data.rootTabChildren);
    });
    this.subscriptions.push(sub);
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  onGetResumen(item: IPolizaVitalicia) {
    this.selectedTabIndex = 0;

    if (!this.nombreProd) {
      this.nombreProd = item.TipoPension;

      this.eventSrv.addRouteToRouterTree({
        path: '',
        label: this.nombreProd,
        tabIndexes: { rootTabParent: 0, rootTabChildren: 0 },
      });

      this.eventSrv.addRouteToRouterTree({
        path: '',
        label: this.tab.tabs[0].label,
      });
      this.eventSrv.addRouteToRouterTree({
        path: '',
        label: this.tab.tabs[0].tabGroup
          ? this.tab.tabs[0].tabGroup.tabs[0].label
          : '',
      });
    }
  }

  setTabIndex(index: number, childIndex: number) {
    this.tab.selectedIndex = index;
    const selectedTab = this.tab.tabs.find(x => x.index === index);

    // this.getPrintData(null);
    this.selectedTabIndex = index;
    this.mappingPageViewToTabs(index);

    if (!childIndex) {
      this.eventSrv.addRouteToRouterTree(
        {
          path: '',
          label: selectedTab.label,
        },
        1
      );
    } else {
      this.eventSrv.addRouteToRouterTree(
        {
          path: '',
          label: !this.tab.tabs[index].tabGroup.tabs[childIndex]
            ? ''
            : this.tab.tabs[index].tabGroup.tabs[childIndex].label,
        },
        1
      );
    }
  }

  ngOnInit() {
    console.log('Privado main==');
    return;
    this.idPoliza = this.route.snapshot.paramMap.get('id');
    this.tipo = this.route.snapshot.queryParamMap.get('tipo');
    this.numPersona = this.route.snapshot.queryParamMap.get('numPersona');
    this.activateMenu();

    this.mappingPageViewToTabs(0);
    const menuSubscription = this.eventSrv.menuChange$.subscribe(() => {
      this.activateMenu();
    });
    this.subscriptions.push(menuSubscription);
  }
  activateMenu() {
    const menu = this.eventSrv
      .getMenu()
      .items.find(x => x.route.path === 'privado');

    if (!menu) {
      return;
    }
    menu.active = true;

    const element = menu.children.find(c => c.id.toString() === this.idPoliza);
    if (!element) {
      return;
    }
    element.active = true;
  }

  private getListPageViewName() {
    return [
      PageView.piSummaryView,
      PageView.piLiquidationView,
      PageView.piLegalGuardianshipView,
      PageView.piRescueView,
    ];
  }

  private mappingPageViewToTabs(index: number) {
    const viewName = this.getListPageViewName()[index];
    this.captureScreenTime(viewName);
    this.appInsightsService.uuid = uuidv4();
    this.appInsightsService.pageViewActive = {
      viewName,
      label: getValuePageView[viewName],
    };
    this.appInsightsService.trackPageView(
      this.getListPageViewName()[index],
      this.router.url,
      {
        tabParent: this.tab.tabs[index].label,
      }
    );
  }

  private captureScreenTime(nameTrack: string) {
    if (this.previousNameTrack !== nameTrack) {
      if (!this.previousNameTrack) {
        this.appInsightsService.startTrackEvent(Event.ceScreenTime);
      } else {
        this.appInsightsService.stopTrackEvent(Event.ceScreenTime, {
          pageViewName: this.previousNameTrack,
        });
        this.appInsightsService.startTrackEvent(Event.ceScreenTime);
      }
      this.previousNameTrack = nameTrack;
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
  getPrintData(data) {
    this.printData = data;
  }
}
